import { ENV_VARS } from '@/env';
import { CitySelect, CountrySelect, StateSelect } from '@/views/screens/common';
import { Col, Form, Row } from 'antd';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { getPortSearchProgress } from '../../../../redux/common/CommonActions';
import Button from '../../../components/Buttons/Button';
import FormInput from '../../../components/Inputs/FormInput';
import PortCodeSelector from '../../../components/Selectors/PortCodeSelector';
import PortTypeSelector from '../../../components/Selectors/PortTypeSelector';
import { useBehaviorForAddressFields } from '../CustomHooks/SearchQuoteHooks';

const PortSearchForm = ({ formInstance, onSubmit, labelForTestId }) => {
  const dispatch = useDispatch();
  let [form] = Form.useForm();
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

  if (formInstance) {
    form = formInstance;
  }

  const countryCode = Form.useWatch('countryCode', form);
  const stateCode = Form.useWatch('stateCode', form);
  const portType = Form.useWatch('portType', form);

  useBehaviorForAddressFields(countryCode, stateCode, 'stateCode', 'city', form);

  const handleSearchButton = () => {
    const data = form.getFieldsValue();

    handleSubmit(data);
  };

  const handleSubmit = (data) => {
    const payload = {
      PortCountryCode: data?.countryCode,
      PortState: data?.stateCode,
      PortCity: data?.city,
      PortZip: data?.postalCode,
      PortCode: data?.portCode,
      PortName: data?.portName,
      PortType: data?.portType,
      PageNumber: 1,
      PageSize: 10,
    };
    dispatch(getPortSearchProgress(payload));
    if (onSubmit) {
      onSubmit(data);
    }
  };

  return (
    <Form form={form}>
      <Row gutter={15} data-testid={labelForTestId ? labelForTestId : ''}>
        <Col md={6}>
          <CountrySelect name="countryCode" placeholder={t('translation:default.fields.country.placeholder')} />
          <PortTypeSelector name="portType" margin="m-0" />
        </Col>
        <Col md={6}>
          <FormInput
            name="portName"
            label={t('translation:default.fields.portName.label')}
            placeholder={t('translation:default.fields.portName.enter')}
            editMode
            margin="mb-15"
          />
          <PortCodeSelector
            name="portCode"
            form={form}
            label={t('translation:default.fields.portCode.label')}
            editMode
            portType={portType}
            handleValueRender={(data) => data?.text}
            countryCode={countryCode}
          />
        </Col>

        <Col md={6}>
          <FormInput
            name="postalCode"
            label={t('translation:default.fields.postalCode.label')}
            placeholder={t('translation:default.fields.postalCode.placeholder')}
            editMode
          />
          <StateSelect name="stateCode" countryCode={countryCode} />
        </Col>

        <Col md={6}>
          <CitySelect name="city" countryCode={countryCode} stateCode={stateCode} />
        </Col>
      </Row>
      <Row justify="end" gutter={15}>
        <Col data-testid={labelForTestId ? `${labelForTestId}-search-button` : ''}>
          <Button buttonType="button" onClick={handleSearchButton} className={isHBUser ? 'hb-button' : ''}>
            {t('translation:default.buttons.search')}
          </Button>
        </Col>
        <Col data-testid={labelForTestId ? `${labelForTestId}-clear-button` : ''}>
          <Button onClick={() => form.resetFields()} type="default" className={isHBUser ? 'hb-button' : ''}>
            {t('translation:default.buttons.clear')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PortSearchForm;
